import PQueue from "p-queue";
import { RealQueueClass } from ".";
/**
 * Create a page-wide queue saved in `window`.
 */ function getGlobalQueue() {
    if (!window.realQueueInstancePQueue) {
        window.realQueueInstancePQueue = new PQueue({
            autoStart: true,
            concurrency: 1,
            queueClass: RealQueueClass
        });
    }
    return window.realQueueInstance;
}
export { getGlobalQueue };
